(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-account-details"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    new CustomerAddresses();
    new CustomerDetails();
    new B2BLocationEditor();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-navbar"]) return;
  try {
    
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const menuDropdown = document.querySelector('.menu-dropdown');

  if (menuBtn && menuDropdown) {
    menuBtn.addEventListener('click', (event) => {
      event.stopPropagation();
      menuDropdown.classList.toggle('active');
    });

    document.addEventListener('click', (event) => {
      if (
        menuDropdown.classList.contains('active') &&
        !menuDropdown.contains(event.target) &&
        !menuBtn.contains(event.target)
      ) {
        menuDropdown.classList.remove('active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-order-history"]) return;
  try {
    
  document.addEventListener('click', async function(e) {
    const wrapper = e.target.closest('.reorder-wrapper');
    if (!wrapper) return;

    const button = wrapper.querySelector('button.r-button');
    const content = button.querySelector('.r-button__content');
    const items = JSON.parse(wrapper.dataset.items);

    let spinner = button.querySelector('.loading__spinner__add-to-cart');
    if (!spinner) {
      spinner = document.createElement('div');
      spinner.className = 'loading__spinner__add-to-cart';
      button.appendChild(spinner);
    }

    button.classList.add('is-loading');
    if (content) content.style.display = 'none';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Failed to add items to cart');
      window.location.href = '/cart';
    } catch (err) {
      console.error('Reorder error:', err);
      button.classList.remove('is-loading');
      if (content) content.style.display = 'flex';
      spinner.remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-shop-all-main"]) return;
  try {
    
  const desktopTabs = document.querySelectorAll('.tab');
  const mobileTabs = document.querySelectorAll('.tab-mobile-btn');
  const sections = document.querySelectorAll('.section');

  function resetTabs() {
    for (const tab of desktopTabs) {
      tab.classList.remove('active');
    }

    for (const tab of mobileTabs) {
      tab.classList.remove('active');
    }

    for (const section of sections) {
      section.style.display = 'none';
    }
  }

  function switchTab(tabId) {
    resetTabs();

    if (tabId === 'shop-all') {
      desktopTabs[0]?.classList.add('active');

      mobileTabs[0]?.classList.add('active');
      for (const section of sections) {
        section.style.display = 'flex';
      }
    } else {
      const desktopTab = Array.from(desktopTabs).find(tab =>
        tab.dataset.tabId === tabId
      );
      desktopTab?.classList.add('active');

      const mobileTab = Array.from(mobileTabs).find(tab =>
        tab.dataset.tabId === tabId
      );
      mobileTab?.classList.add('active');

      document.getElementById(`${tabId}-section`).style.display = 'flex';
    }
  }

  for (const tab of desktopTabs) {
    tab.addEventListener('click', () => switchTab(tab.dataset.tabId));
  }

  for (const tab of mobileTabs) {
    tab.addEventListener('click', () => switchTab(tab.dataset.tabId));
  }

  switchTab('shop-all');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-events"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const VISIBLE_LIMIT = 3;

    document.querySelectorAll('[data-section-type="community-events"]').forEach(function (section) {
      const tabsContainer = section.querySelector('.community-events__tabs');
      const cards = Array.from(section.querySelectorAll('.event-card'));

      // Build one tab per distinct category actually in use, in first-seen order, reading each
      // card's own data-event-type (filter key) and badge text (display label). This has to run
      // client-side rather than in Liquid — see the section comment above.
      const iconMarkup = tabsContainer.querySelector('.community-events__tab-icon').outerHTML;
      const seenFilters = [];
      cards.forEach(function (card) {
        const filter = card.getAttribute('data-event-type');
        if (!filter || seenFilters.indexOf(filter) !== -1) return;
        seenFilters.push(filter);
        const badgeText = card.querySelector('.event-card__badge-text');
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'community-events__tab';
        tab.setAttribute('data-filter', filter);
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', 'false');
        tab.innerHTML = iconMarkup + '<span>' + (badgeText ? badgeText.textContent : filter) + '</span>';
        tabsContainer.appendChild(tab);
      });

      const tabs = section.querySelectorAll('.community-events__tab');
      const validFilters = Array.from(tabs).map(function (t) { return t.getAttribute('data-filter'); });
      const seeMoreButton = section.querySelector('.community-events__cta');

      // Chronological order (soonest first), independent of the DOM/editor order.
      const sortedCards = cards.slice().sort(function (a, b) {
        return new Date(a.getAttribute('data-event-date')) - new Date(b.getAttribute('data-event-date'));
      });

      const params = new URLSearchParams(window.location.search);

      const requestedFilter = params.get('events_filter');
      const initialFilter = validFilters.indexOf(requestedFilter) !== -1 ? requestedFilter : 'all';
      if (initialFilter !== 'all') {
        tabs.forEach(function (t) {
          const isMatch = t.getAttribute('data-filter') === initialFilter;
          t.classList.toggle('is-active', isMatch);
          t.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });
      }

      const requestedShown = parseInt(params.get('events_shown'), 10);
      let visibleCount = requestedShown && requestedShown > VISIBLE_LIMIT ? requestedShown : VISIBLE_LIMIT;

      function updateQueryParam(filter) {
        const url = new URL(window.location.href);

        if (filter === 'all') {
          url.searchParams.delete('events_filter');
        } else {
          url.searchParams.set('events_filter', filter);
        }

        if (visibleCount <= VISIBLE_LIMIT) {
          url.searchParams.delete('events_shown');
        } else {
          url.searchParams.set('events_shown', String(visibleCount));
        }

        history.replaceState(null, '', url);
      }

      function render() {
        const activeTab = section.querySelector('.community-events__tab.is-active');
        const filter = activeTab ? activeTab.getAttribute('data-filter') : 'all';

        const matching = sortedCards.filter(function (card) {
          return filter === 'all' || card.getAttribute('data-event-type') === filter;
        });

        sortedCards.forEach(function (card) {
          const index = matching.indexOf(card);
          const visible = index !== -1 && index < visibleCount;
          card.classList.toggle('is-hidden', !visible);
        });

        if (seeMoreButton) {
          seeMoreButton.hidden = visibleCount >= matching.length;
        }

        updateQueryParam(filter);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          visibleCount = VISIBLE_LIMIT;
          render();
        });
      });

      if (seeMoreButton) {
        seeMoreButton.addEventListener('click', function () {
          visibleCount += VISIBLE_LIMIT;
          render();
        });
      }

      render();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["default-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('[data-section-type="reviews"]');
  if (!section) return;

  // Check if Swiper is available
  if (typeof Swiper === 'undefined') return;

  const carousel = section.querySelector('.reviews__carousel');
  if (!carousel) return;

  const swiperWrapper = carousel.querySelector('.reviews__swiper-wrapper');
  if (!swiperWrapper) return;

  // Clone slides 2x for smooth looping
  const originalSlides = Array.from(swiperWrapper.querySelectorAll('.reviews__slide'));
  for (let i = 0; i < 2; i++) {
    originalSlides.forEach(function(slide) {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('data-shopify-editor-block'); // Remove editor attributes from clones
      swiperWrapper.appendChild(clone);
    });
  }

  // Init Swiper
  new Swiper(carousel, {
    slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 12,
    loop: true,
    speed: 600,
    navigation: {
      nextEl: '.reviews__nav--next',
      prevEl: '.reviews__nav--prev',
    },
    pagination: {
      el: '.reviews__pagination',
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
    breakpoints: {
      768: { slidesPerView: 'auto', spaceBetween: 20, centeredSlides: true },
      1024: { slidesPerView: 'auto', spaceBetween: 24, centeredSlides: true },
    },
    grabCursor: true,
    keyboard: { enabled: true, onlyInViewport: true },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setAnnouncementBarHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementBarHeight() {
      if (this.announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.announcementBar.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.announcementBar.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= 1) {
        this.header.classList.remove('scrolled-past-header');
        this.announcementBar.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }
      

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.announcementBar.classList.add('shopify-section-announcement-bar-section-hidden', 'announcement-bar-section-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.announcementBar.classList.add('announcement-bar-section-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.announcementBar.classList.remove('shopify-section-announcement-bar-section-hidden');

    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.announcementBar.classList.remove('shopify-section-announcement-bar-section-hidden', 'announcement-bar-section-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-banner-v2"] && !Shopify.designMode) return;
  try {
    
  const scrollers = document.querySelectorAll('.unit203_scroller');

  addAnimation();

  function addAnimation() {
    scrollers.forEach((scroller) => {
      // add data-animated="true" to every `.unit203_scroller` on the page
      scroller.setAttribute('data-animated', true);

      // Make an array from the elements within `.unit203_scroller-inner`
      const scrollerInner = scroller.querySelector('.unit203_scroller__inner');
      const scrollerContent = Array.from(scrollerInner.children);

      // For each item in the array, clone it and add it into the
      // `.unit203_scroller-inner`. The whole scroller is aria-hidden,
      // so per-clone aria-hidden is unnecessary.
      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        scrollerInner.appendChild(duplicatedItem);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mushroom-blend"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Initialize GSAP animations
  const path = document.querySelectorAll(".mushroom-blend__line");
  const svgContainer = document.querySelector(".mushroom-blend__svg");
  const textToSplit = document.querySelector(".mushroom-blend__heading");

  // Create GSAP timeline for coordinated animations
  function mushroomBlendTimeline() {
    const tl = gsap.timeline();
    // SVG path drawing animation
    if (path) {
      path.forEach(pathEl => {
        gsap.set(pathEl, { drawSVG: "0%" });
        tl.to(pathEl, {
          drawSVG: "100%",
          duration: 1.5,
          ease: "power2.out"
        }, 0);
      });
    }
    // Text reveal animation with word-by-word effect
    if (textToSplit) {
      let split = SplitText.create(textToSplit, {
        type: "words",
        wordClass: "word-wrapper",
        mask: "words",
      });
      const midPoint = Math.floor(split.words.length / 2);
      // Set initial state for words
      gsap.set(split.words, { autoAlpha: 0, filter: (index) => `blur(${1 + Math.random() * 7}px)` });
      // Create staggered animation from center outward
      split.words.forEach((word, index) => {
        const delay = Math.abs(index - midPoint) * 0.1;
        tl.to(word, {
          autoAlpha: 1,
          ease: "power3.out",
          duration: 1.5,
          filter: "blur(0px)",
          stagger: {
            amount: 2,
            grid: "auto",
            axis: "x",
            ease: "power3.out",
            from: "random"
          }
        }, delay);
      });
    }
    // Show SVG and heading
    if (svgContainer) tl.set(svgContainer, { opacity: 1 }, 0);
    if (textToSplit) tl.set(textToSplit, { opacity: 1 }, 0);
    return tl;
  }

  // Use GSAP ScrollTrigger to trigger the animation
  if (typeof ScrollTrigger !== 'undefined' && typeof gsap !== 'undefined') {
    ScrollTrigger.create({
      trigger: ".mushroom-blend__header",
      start: "top 80%",
      once: true,
      onEnter: () => {
        const timeline = gsap.timeline();
        timeline.add(mushroomBlendTimeline());
      }
    });
  } else {
    // Fallback: show heading and SVG if GSAP/ScrollTrigger not available
    if (svgContainer) svgContainer.style.opacity = 1;
    if (textToSplit) textToSplit.style.opacity = 1;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-community"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    // Initialize GSAP animations
  const path = document.querySelectorAll(".draw-path__community");
  const svgContainer = document.querySelector(".our-community__underline");
  const textToSplit = document.querySelector(".our-community__subheading");

  // Create GSAP timeline for coordinated animations
  function communityTimeline() {
    const tl = gsap.timeline();
    // SVG path drawing animation
    if (path) {
      path.forEach(pathEl => {
        gsap.set(pathEl, { drawSVG: "0%" });
        tl.to(pathEl, {
          drawSVG: "100%",
          duration: 1.5,
          ease: "power2.out"
        }, 0);
      });
    }
    // Text reveal animation with word-by-word effect
    if (textToSplit) {
      let split = SplitText.create(textToSplit, {
        type: "words",
        wordClass: "word-wrapper",
        mask: "words",
      });
      const midPoint = Math.floor(split.words.length / 2);
      // Set initial state for words
      gsap.set(split.words, { autoAlpha: 0, filter: (index) => `blur(${1 + Math.random() * 7}px)` });
      // Create staggered animation from center outward
      split.words.forEach((word, index) => {
        const delay = Math.abs(index - midPoint) * 0.1;
        tl.to(word, {
          autoAlpha: 1,
          ease: "power3.out",
          duration: 1.5,
          filter: "blur(0px)",
          stagger: {
            amount: 2,
            grid: "auto",
            axis: "x",
            ease: "power3.out",
            from: "random"
          }
        }, delay);
      });
    }
    // Show SVG and heading
    if (svgContainer) tl.set(svgContainer, { opacity: 1 }, 0);
    if (textToSplit) tl.set(textToSplit, { opacity: 1 }, 0);
    return tl;
  }

  // Use GSAP ScrollTrigger to trigger the animation
  if (typeof ScrollTrigger !== 'undefined' && typeof gsap !== 'undefined') {
    ScrollTrigger.create({
      trigger: ".our-community__content",
      start: "top 80%",
      once: true,
      onEnter: () => {
        var master = gsap.timeline();
        master.add(communityTimeline());
      }
    });
  } else {
    // Fallback: show heading and SVG if GSAP/ScrollTrigger not available
    if (svgContainer) svgContainer.style.opacity = 1;
    if (textToSplit) textToSplit.style.opacity = 1;
  }

  const swiperInstance = new Swiper(".mySwiper", {
    loop: true,
    slidesPerView: 1.3,
    spaceBetween: 16,
    watchSlidesProgress: true,
    freeMode: false,
    navigation: {
      nextEl: ".new-swiper-button-next",
      prevEl: ".new-swiper-button-prev",
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      480: { 
        slidesPerView: 1.8 
      },
      640: { 
        slidesPerView: 2.2, 
        spaceBetween: 24,
      },
      768: { 
        slidesPerView: 2.8 
      },
      990: { 
        slidesPerView: 3.4 
      },
      1100: { 
        slidesPerView: 4
      },
    },
  });

  document.querySelectorAll(".play_icon")?.forEach((playIcon) => {
    playIcon.addEventListener("click", function (e) {
      // Pause Swiper autoplay
      swiperInstance?.autoplay?.stop();

      // Pause all videos
      document.querySelectorAll(".our-community__slide video")?.forEach((video) =>
        video.pause()
      );

      // Replace image with video
      const parent = playIcon.closest(
        `.oc_slide_single_${playIcon.getAttribute("data-uuid")}`
      );
      const videoUrl = playIcon.dataset.video;
      const mime_type = playIcon.dataset.mimeType;

      if (videoUrl && mime_type) {
        parent.innerHTML = `<video width="100%" height="100%" controls autoplay loop>
          <source src="${videoUrl}" type="${mime_type}">
          Your browser does not support the video tag.
        </video>`;

        const newVideo = parent.querySelector("video");

        // Resume autoplay when the video ends (optional)
        newVideo?.addEventListener("ended", () => {
          swiperInstance?.autoplay?.start();
        });
      }
    });
  });
});

document.addEventListener('click', function(event) {
  if (window.innerWidth >= 768) return;

  const communityMain = document.querySelector('.our_community_main .mySwiper');
  const scrolledElement = document.querySelector('.our-community__scrolled');

  if (!communityMain || !scrolledElement) return;

  const clickedInsideCommunity = communityMain.contains(event.target);
  const clickedPlayIcon = event.target.closest('.play_icon');

  if (!clickedInsideCommunity && !clickedPlayIcon) {
    scrolledElement.classList.toggle('our-community__scrolled2');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ryze-hf-heading"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const heroButton = document.querySelector('.hf-hero-button');

    if (heroButton) {
      heroButton.addEventListener('click', function(e) {
        e.preventDefault();

        const productSection = document.querySelector('.shopify-section.shopAll-productBlock-section.shopAll-productBlock');

        if (productSection) {
          productSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ryze-product-gifts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperEl = document.querySelector('.product-gifts-swiper');
    if (!swiperEl) return;

    const isDesktopSlider = swiperEl.closest('.product-gifts__wrapper').classList.contains('is-slider-desktop');

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,

      simulateTouch: true,
      grabCursor: true,
      touchStartPreventDefault: false,

      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },

      navigation: {
        nextEl: '.swiper-gifts-next',
        prevEl: '.swiper-gifts-prev'
      },

      breakpoints: {
        0: { slidesPerView: 'auto', centeredSlides: true, spaceBetween: 16  },
        768: { slidesPerView: 2, centeredSlides: false} ,
        992: { slidesPerView: 3, centeredSlides: false },
        1200: { slidesPerView: 4, centeredSlides: false, allowTouchMove: isDesktopSlider }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
